import "./CrpClientsList.scss"
import React, { useEffect, useState } from 'react'
import { useGetAllCRPClientsQuery } from '../../../services/kmt/crpClient.service'
import GenericDataTable from '../../../components/generic-datatable/GenericDataTable'
import { Column } from 'primereact/column'
import { CRP_CLIENTS_LIST_KEYS, CRP_CLIENTS_TABLE_HEADERS } from './CrpClientsList.config'
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext'
import { ReactComponent as EyeIcon } from "../assets/eyeOutline.svg";
import { Button } from "primereact/button"
import MailLogs from "./mail-logs/MailLogs"
import { useToggle } from "../../../hooks"

const CrpClientsList = () => {
  const { data: CRPClientsResponse, isLoading, isError } = useGetAllCRPClientsQuery()
  const [isLogsModalVisible, setIsLogsModalVisible] = useToggle(false)
  const [activeClientIndex, setActiveClientIndex] = useState(0)

  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [filterValue, setFilterValue] = useState('');

  if (isLoading) {
    return <>Loading...</>
  }
  if (isError) {
    return <>There was some error while retrieving the clients details</>
  }
  const onFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setFilterValue(value);
  }

  const { clients } = CRPClientsResponse

  const bodyTemplate = (data, column) => {
    if (column.field === CRP_CLIENTS_LIST_KEYS.IS_ACTIVE) {
      const activeText = data[CRP_CLIENTS_LIST_KEYS.IS_ACTIVE] ? "Active" :"Disabled"
      const severity = data[CRP_CLIENTS_LIST_KEYS.IS_ACTIVE]? "success":"danger"
      return <Button label={activeText} severity={severity} outlined disabled={true}/>
    }
    if (column.field === CRP_CLIENTS_LIST_KEYS.EMAIL_LOGS) {
      return <div onClick={() => { setActiveClientIndex(column.rowIndex); setIsLogsModalVisible()}} className="cursor-pointer"><EyeIcon/></div>
    }
    if(column.field === CRP_CLIENTS_LIST_KEYS.CLIENT_NAME) {
      console.log("🚀 ~ file: CrpClientsList.jsx:51 ~ bodyTemplate ~ data:", data)
      return <div>{data?.CIPAuthClientDoc?.clientName}</div>
    }
  }
  return (
    <div className='CrpClientsList p-4'>
      <MailLogs activeClientIndex={activeClientIndex} CRPClientsResponse={CRPClientsResponse}  visible={isLogsModalVisible} onHide={setIsLogsModalVisible} />
      <h3 className='mb-2'>CRP Clients</h3>
      <div className="flex justify-content-end mb-4">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={filterValue} onChange={onFilterChange} placeholder="Search" />
        </span>
      </div>
      <div className="DataTable">
        <GenericDataTable paginator rows={10} filters={filters} tableClassName='white-space-nowrap font-medium' spacedRows={true} value={clients} sortMode="multiple" responsiveLayout="scroll">
          <Column field={CRP_CLIENTS_LIST_KEYS.EMAIL} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.EMAIL]} align="center" />
          <Column field={CRP_CLIENTS_LIST_KEYS.CLIENT_NAME} body={bodyTemplate} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.CLIENT_NAME]} align="center" />
          <Column field={CRP_CLIENTS_LIST_KEYS.FIRST_NAME} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.FIRST_NAME]} align="center" />
          <Column field={CRP_CLIENTS_LIST_KEYS.LAST_NAME} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.LAST_NAME]} align="center" />
          {/* <Column field={CRP_CLIENTS_LIST_KEYS.IS_ACTIVE} body={bodyTemplate} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.IS_ACTIVE]} align="center" /> */}
          <Column field={CRP_CLIENTS_LIST_KEYS.EMAIL_LOGS} body={bodyTemplate} header={CRP_CLIENTS_TABLE_HEADERS[CRP_CLIENTS_LIST_KEYS.EMAIL_LOGS]} align="center" />
        </GenericDataTable>
      </div>
    </div>
  )
}

export default CrpClientsList